module.exports = __webpack_public_path__ + "fonts/Hgo13k-tfSpn0qi1SFdUfZBw1xU1rKptJj_0jans920.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/content/fonts/roboto-font/Hgo13k-tfSpn0qi1SFdUfZBw1xU1rKptJj_0jans920.woff2
// module id = 324
// module chunks = 0